/* eslint-disable no-param-reassign */
import { UIKitSettingsBuilder } from '@cometchat/uikit-shared';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  chatCreateUserOperation,
  chatLogInUserOperation,
} from '../../operations/chat_operations';
import { CometChatUIKit } from '../../components/common/cometchat-uikit-react/Shared/CometChatUIKit/CometChatUIKit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';

export interface EndUserChatState {
  chatAuthToken: string | null | undefined;
}

const initialState: EndUserChatState = {
  chatAuthToken: null,
};

export const endUserChatSlice = createSlice({
  name: 'endUserChat',
  initialState,
  reducers: {
    // increment: (state) => {
    //   // Redux Toolkit allows us to write "mutating" logic in reducers. It
    //   // doesn't actually mutate the state because it uses the Immer library,
    //   // which detects changes to a "draft state" and produces a brand new
    //   // immutable state based off those changes
    //   state.value += 1
    // },
    // decrement: (state) => {
    //   state.value -= 1
    // },
    // incrementByAmount: (state, action: PayloadAction<number>) => {
    //   state.value += action.payload
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(chatLogInUser.fulfilled, (state, action) => {
      state.chatAuthToken = action.payload?.authToken;
    });
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.chatAuthToken = null;
    });
  },
});

const initChat = async (
  appID: string,
  appRegion: string,
  authToken: string,
) => {
  const UIKitSettings = new UIKitSettingsBuilder()
    .setAppId(appID)
    .setRegion(appRegion)
    .subscribePresenceForAllUsers()
    .build();

  await CometChatUIKit.init(UIKitSettings);

  console.log('Chat initialization completed successfully');
  let cometChatUser = await CometChatUIKit.getLoggedinUser();
  if (!cometChatUser) {
    cometChatUser = await CometChatUIKit.loginWithAuthToken(authToken);
  }
  if (cometChatUser) {
    console.log('Chat user logged in successfully');
  } else {
    console.warn('Chat user fail to log in');
  }
};

export const chatLogInUser = createAsyncThunk(
  'chat/logInUser',
  // Declare the type your function argument here:
  async ({
    appID,
    appRegion,
    chatNickname,
    spaceMembershipID,
  }: {
    appID: string;
    appRegion: string;
    chatNickname: string;
    spaceMembershipID: string;
  }) => {
    try {
      console.log(`Logging in chat user ${spaceMembershipID}`);
      const loginResult = await chatLogInUserOperation(spaceMembershipID);
      await initChat(appID, appRegion, loginResult.authToken);
      return loginResult;
    } catch (e) {
      console.warn(e);
      console.log(
        `Attempting to create chat user ${spaceMembershipID} ${chatNickname}`,
      );
      const createUserResult = await chatCreateUserOperation(
        spaceMembershipID,
        chatNickname,
      );
      if (createUserResult.authToken) {
        await initChat(appID, appRegion, createUserResult.authToken);
        return createUserResult;
      }
    }
    return null;
  },
);

export default endUserChatSlice.reducer;
